<div class="service-page">
  <header class="page-hero">
    <h1>La infraestructura de tu web, gestionada con claridad.</h1>
    <p class="hero-lead">
      Nos ocupamos de gestionar el hosting y el dominio asociados al desarrollo para que la empresa
      tenga un punto de apoyo técnico definido.
    </p>
    <a class="button button-primary" routerLink="/contacto">Consultar la gestión técnica</a>
  </header>

  <section class="split-section" aria-labelledby="hosting-need-title">
    <div class="section-heading">
      <h2 id="hosting-need-title">Hosting, dominio y web deben funcionar como un conjunto.</h2>
    </div>
    <ul class="check-list">
      <li>No quieres gestionar configuraciones técnicas por tu cuenta.</li>
      <li>Necesitas coordinar el alojamiento con una nueva web.</li>
      <li>Quieres tener controladas las renovaciones del dominio.</li>
      <li>Buscas un interlocutor para la infraestructura asociada al proyecto.</li>
    </ul>
  </section>

  <section aria-labelledby="hosting-scope-title">
    <div class="section-heading">
      <h2 id="hosting-scope-title">Una gestión vinculada a las necesidades del proyecto.</h2>
      <p>El proveedor, los recursos y las condiciones se concretan según la web desarrollada.</p>
    </div>
    <div class="feature-grid feature-grid-three">
      <article>
        <span>01</span>
        <h3>Hosting</h3>
        <p>Configuración y gestión del alojamiento adecuado para el proyecto.</p>
      </article>
      <article>
        <span>02</span>
        <h3>Dominio</h3>
        <p>Gestión técnica del dominio y de su conexión con los servicios necesarios.</p>
      </article>
      <article>
        <span>03</span>
        <h3>Seguimiento</h3>
        <p>Control de los elementos gestionados y coordinación ante cambios o renovaciones.</p>
      </article>
    </div>
  </section>

  <section class="pricing-section" aria-labelledby="hosting-price-title">
    <div>
      <h2 id="hosting-price-title">19 €/mes o 190 €/año + IVA</h2>
    </div>
    <p>
      El servicio se contrata de forma independiente al mantenimiento y está disponible para
      landings esenciales y webs profesionales desarrolladas por ATSIestudio.
    </p>
  </section>

  <section class="split-section" aria-labelledby="hosting-includes-title">
    <div class="section-heading">
      <h2 id="hosting-includes-title">Infraestructura estándar gestionada.</h2>
      <p>
        Webs avanzadas y desarrollos personalizados se presupuestan según las necesidades técnicas
        del proyecto.
      </p>
    </div>
    <ul class="check-list">
      <li>Alojamiento de la web y configuración inicial.</li>
      <li>Dominio y certificado SSL.</li>
      <li>Gestión técnica del despliegue.</li>
      <li>Configuración de DNS.</li>
      <li>Supervisión básica de disponibilidad.</li>
      <li>Renovaciones y mantenimiento de la infraestructura estándar.</li>
    </ul>
  </section>

  <section class="service-restriction" aria-labelledby="hosting-restriction-title">
    <h2 id="hosting-restriction-title">Disponible solo para proyectos de ATSIestudio.</h2>
    <p>
      El servicio de hosting y dominio no puede contratarse para proyectos que no hayan sido
      desarrollados por ATSIestudio.
    </p>
  </section>

  <section class="faq-section" aria-labelledby="hosting-faq-title">
    <div class="section-heading">
      <h2 id="hosting-faq-title">Sobre hosting y dominios.</h2>
    </div>
    <div class="faq-list">
      <details>
        <summary>¿El dominio sigue perteneciendo al cliente?</summary>
        <p>
          La titularidad y las condiciones concretas deben quedar identificadas en la propuesta y en
          la cuenta del proveedor correspondiente.
        </p>
      </details>
      <details>
        <summary>¿Está incluido el coste del proveedor?</summary>
        <p>
          El precio indicado cubre la infraestructura estándar descrita para una landing esencial o
          una web profesional. Cualquier necesidad adicional se detallará en el presupuesto.
        </p>
      </details>
      <details>
        <summary>¿Podéis alojar una web desarrollada por otra empresa?</summary>
        <p>
          No. El servicio de hosting y dominio se ofrece únicamente para proyectos desarrollados por
          ATSIestudio.
        </p>
      </details>
    </div>
  </section>

  <section class="service-cta" aria-labelledby="hosting-cta-title">
    <h2 id="hosting-cta-title">Hablemos de la infraestructura de tu proyecto.</h2>
    <p>Cuéntanos si partes de cero o ya tienes dominio y alojamiento.</p>
    <a class="button button-primary" routerLink="/contacto">Solicitar una valoración</a>
  </section>
</div>
